import './App.css';
import { variableName } from './variableName';
function Pfooter() {

    return (
        <>
            <div className="P_footer">
                <p>By Reliable Software, Goa. <span className="white">Ph: {variableName.relyPhone}</span> </p>
            </div>
        </>
    )
}

export default Pfooter;